import React, { useContext, useEffect, useState } from 'react'
import * as S from './styles'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import DocumentAccordeon from 'presentation/shared/layouts/DocumentAccordeon'
import Procedures from './Accordions/Procedures'
import ClinicalHistory from './Accordions/ClinicalHistory'
import ClinicalRecord from './Accordions/ClinicalRecord'
import GeneralComments from './Accordions/GeneralComments'
import OpmeAndSuppliers from './Accordions/OpmeAndSuppliers'
import PatientAndInsuranceData from './Accordions/PatientAndInsuranceData'
import QueueNumber from './Accordions/QueueNumber'
import { ReactComponent as CheckCircle } from 'presentation/assets/icons/check-circle.svg'
import { ReactComponent as AlertCircle } from 'presentation/assets/icons/alert-circle.svg'
import { ReactComponent as Arrow } from 'presentation/assets/icons/v-arrow.svg'
import { SurgicalOrderContext } from 'main/factories/pages/doctor/surgical-order/surgical-order-factory'
import { useServices } from 'presentation/hooks/use-services'
import { useStores } from 'presentation/hooks/use-stores'
import { toast } from 'react-toastify'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { renameFile } from 'common/utils/file/renameFile'
import { Document } from 'domain/entities/document'
import { DocumentsList } from 'common/enum/documents-list'
import downloadFileFromBlob from 'common/utils/downloadFileFromBlob'
import moment from 'moment-timezone'
import AccordionCardNew from 'presentation/shared/components/AccordionCardNew'
import { OpenSurgicalOrderPatientDocument } from 'common/enum/patient-document'
import { ReportsCard } from 'presentation/shared/layouts/ReportsCard'
import { Patient } from 'domain/entities/patient-model'
import { Cooperative } from './Accordions/Coopertive'
import { SurgicalOrderNew } from 'domain/entities/surgical-order-new'
import { AnesthesiologyType } from 'domain/usecases/surgical-order/load-guides-by-type'
import { HealthInsurancePlans } from 'domain/usecases/health-insurance/load-health-insurance-plans'
import { Opme } from 'domain/entities/surgical-order-opme-model'
import { Separator } from 'presentation/shared/components/Separator'
import UploadButtonNew from 'presentation/shared/components/UploadButtonNew'
import { SurgicalOrderStatus } from 'presentation/shared/components/Timeline/status'
import { getSurgicalOrderStatusLabelByEnum } from 'presentation/utils/surgical-order-status'
import { useHistory } from 'react-router'
import { FinalizedOrderType } from 'domain/usecases/surgical-order/get-finalize-surgical-orders-history'
import { useDocumentUpload } from 'presentation/hooks/useDocumentUpload'
import { getUploadLogger } from 'common/utils/upload-logger'

const logger = getUploadLogger()

type Props = WithLoadingProps

const PlanningTab = ({ setIsLoading }: Props) => {
  const { state } = useContext<any>(SurgicalOrderContext)
  const [finishedAccordionOpen, setFinishedAccordionOpen] = useState('')
  const [informationAccordionOpen, setInformationAccordionOpen] = useState('')
  const [mainInformationAccordionOpen, setMainInformationAccordionOpen] =
    useState('')
  const [mainReportsAccordionOpen, setMainReportsAccordionOpen] = useState('')
  const [mainOtherDocumentsAccordionOpen, setMainOtherDocumentsAccordionOpen] =
    useState('')
  const [responseData, setResponseData] = useState<SurgicalOrderNew>(
    {} as SurgicalOrderNew
  )
  const [documents, setDocuments] = useState<Document[]>([])
  const [opmeProviders, setOpmeProviders] = useState<string[]>([])
  const [opmeSolicitation, setOpmeSolicitation] = useState<Opme[]>([])
  const [opmeFinalized, setOpmeFinalized] = useState<any[]>()
  const [anesthesiology, setAnesthesiology] = useState<AnesthesiologyType[]>([])
  const [reportsAccordionOpen] = useState('')
  const surgicalOrderService = useServices().surgicalOrder
  const currentAccount = useStores().currentAccount.getCurrentAccount()
  const uploadService = surgicalOrderService.getUploadService()
  const { uploadDocument: uploadDocumentToS3, resetState } =
    useDocumentUpload(uploadService)
  const HOSPITAL_SALVADOR_ID = 8
  const HOSPITAL_EMEC_ID = 22
  const surgicalOrderStatusReview = getSurgicalOrderStatusLabelByEnum(
    SurgicalOrderStatus.REVIEW
  )
  const surgicalOrderStatusOpmeQuatation = getSurgicalOrderStatusLabelByEnum(
    SurgicalOrderStatus.OPME_QUOTATION
  )
  const history = useHistory()
  const isSurgicalOrderReview =
    responseData.active_status === surgicalOrderStatusReview ||
    responseData.active_status === surgicalOrderStatusOpmeQuatation

  if (!state?.card?.surgical_order_id) {
    toast.error('Ocorreu um erro ao carregar o planejamento cirúrgico')
    history.push('/home')
  }

  const [finalizedOrders, setFinalizedOrders] = useState(
    [] as FinalizedOrderType[]
  )

  const getSurgicalOrderByIdForDocuments = async () => {
    try {
      setIsLoading(true)
      const response = await surgicalOrderService.getSurgicalOrderById({
        surgical_order_id: state.card.surgical_order_id
      })
      setResponseData(response)
      setDocuments(response.documents)
      setOpmeProviders(response.opme?.providers as string[])
      setOpmeSolicitation(response.opme?.solicitations as [])
      setOpmeFinalized(getLastFinalizedOrder()?.opme)
      setAnesthesiology(response.anesthesiologies)

      const responseHistory =
        await surgicalOrderService.getFinalizeSurgicalOrdersHistory({
          surgical_order_id: state.card.surgical_order_id
        })

      setFinalizedOrders(responseHistory.data)

      return response
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const documentsList = () => {
    const mappedDocs = mappedDocuments()

    return Object.keys(OpenSurgicalOrderPatientDocument).map((document) => {
      const docs = mappedDocs
        .filter((doc: any) => doc.type === document)
        .sort((a: any, b: any) => {
          if (moment(a.sendedAt).isAfter(b.sendedAt)) return -1
          else if (moment(a.sendedAt).isBefore(b.sendedAt)) return 1
          else return 0
        })

      const filesList = docs.reduce(
        (acc: any, curr: any) => [...acc, ...curr.documents],
        []
      )

      return {
        label: DocumentsList[document as keyof typeof DocumentsList],
        type: document,
        status: docs[0]?.status,
        documents: filesList
      }
    })
  }

  const mappedDocuments = () => {
    return (
      documents.map((document: Document) => ({
        type: document.type,
        status: document.status,
        documents: [
          {
            ...document,
            sended_at: document.sendedAt,
            status_updated_by: {
              name: document.updated_by?.name
            }
          }
        ]
      })) || []
    )
  }

  useEffect(() => {
    setIsLoading(true)
    getSurgicalOrderByIdForDocuments()
  }, [])

  const handleChangeInformationAccordion = (
    label: string,
    isExpanded: boolean
  ) => {
    setInformationAccordionOpen(!isExpanded ? '' : label)
  }

  const handleChangeMainInformationAccordion = (
    label: string,
    isExpanded: boolean
  ) => {
    setMainInformationAccordionOpen(!isExpanded ? '' : label)
  }

  const handleChangeMainReportsAccordion = (
    label: string,
    isExpanded: boolean
  ) => {
    setMainReportsAccordionOpen(!isExpanded ? '' : label)
  }

  const handleChangeMainOtherDocumentsAccordion = (
    label: string,
    isExpanded: boolean
  ) => {
    setMainOtherDocumentsAccordionOpen(!isExpanded ? '' : label)
  }

  const handleChangeFinishedAccordion = (
    label: string,
    isExpanded: boolean
  ) => {
    setFinishedAccordionOpen(!isExpanded ? '' : label)
  }
  const uploadDocument = async (files: any, type: string) => {
    setIsLoading(true)
    resetState()
    try {
      const file = files[0]
      const newFile = renameFile(file, file.name)

      const user = {
        id: currentAccount?.user?.user_id || 0,
        name: currentAccount?.user?.name || '',
        token: currentAccount?.accessToken || ''
      }

      const documentId = await uploadDocumentToS3(
        newFile,
        state.card.surgical_order_id,
        type as any,
        user
      )

      if (!documentId) {
        throw new Error('Falha no upload do documento')
      }

      toast.success('Documento enviado com sucesso')

      setTimeout(async () => {
        try {
          let documentFound = false
          for (let attempt = 1; attempt <= 3; attempt++) {
            await new Promise((resolve) => setTimeout(resolve, 3000))
            const response = await surgicalOrderService.getSurgicalOrderById({
              surgical_order_id: state.card.surgical_order_id
            })

            const newDoc = response.documents.find(
              (doc: any) =>
                doc.type === type &&
                !documents.some((d) => d.document_id === doc.document_id)
            )

            if (newDoc || response.documents.length > documents.length) {
              setResponseData(response)
              setDocuments(response.documents)
              setOpmeProviders(response.opme?.providers as string[])
              setOpmeSolicitation(response.opme?.solicitations as [])
              setOpmeFinalized(getLastFinalizedOrder()?.opme)
              setAnesthesiology(response.anesthesiologies)
              documentFound = true
              break
            }
          }
          if (!documentFound) {
            await getSurgicalOrderByIdForDocuments()
          }

          logger.warn('Timeout: documento ainda não processado pelo backend')
        } catch (error) {
          logger.error('Erro ao verificar processamento do documento', {
            error
          })
        }
      }, 2000)
    } catch (error: any) {
      logger.error('Erro no upload do documento', { error, type })
      toast.error(error?.message || 'Ocorreu um erro ao enviar o documento')
    } finally {
      setIsLoading(false)
    }
  }

  const deleteDocument = async (document_id: number) => {
    setIsLoading(true)
    try {
      await surgicalOrderService.deleteUploadedDocumentsNew({
        document_id
      })

      await getSurgicalOrderByIdForDocuments()
    } catch (error) {
      toast.error('Ocorreu um erro ao deletar o documento')
    } finally {
      setIsLoading(false)
    }
  }

  const downloadDocument = async (
    document_id: number,
    _group_id: string,
    type: keyof typeof DocumentsList,
    fileName?: string
  ) => {
    setIsLoading(true)
    try {
      const surgicalOrderId = state.card.surgical_order_id

      const file: any = await surgicalOrderService.loadSurgicalOrderDocument({
        surgical_order_id: surgicalOrderId,
        document_id
      })

      if (file && file.data) {
        const originalExtension = fileName?.split('.').pop()?.toLowerCase()
        const extension = file.extension || originalExtension || ''
        const downloadName = extension
          ? `${DocumentsList[type]}.${extension}`
          : DocumentsList[type]

        downloadFileFromBlob(file.data, file.contentType, downloadName)
      }
    } catch (error) {
      logger.error('Erro ao baixar documento', {
        surgicalOrderId: state.card.surgical_order_id,
        documentId: document_id,
        documentType: type,
        error
      })
      toast.error('Ocorreu um erro ao baixar o documento')
    } finally {
      setIsLoading(false)
    }
  }

  function getLastFinalizedOrder() {
    if (finalizedOrders?.length === 1) {
      return finalizedOrders[0]
    } else if (finalizedOrders?.length > 1) {
      return finalizedOrders.filter((finalizedOrder: any) => {
        return finalizedOrder.is_active === true
      })[0]
    }
  }

  const finishedItems = [
    <QueueNumber
      key="QueueNumber"
      expanded={finishedAccordionOpen === 'QueueNumber'}
      handleChange={handleChangeFinishedAccordion}
      password={getLastFinalizedOrder()?.password_to_finish}
      expirationText={
        getLastFinalizedOrder()?.password_max_date_validation_status
      }
      expirationDate={
        getLastFinalizedOrder()?.password_max_date_validation as any
      }
      passwordObservation={
        getLastFinalizedOrder()?.password_max_string_validation
      }
      icon={<CheckCircle />}
    />,
    <Procedures
      isFinished
      key="ProceduresAndCid"
      expanded={informationAccordionOpen === 'Procedures'}
      handleChange={handleChangeInformationAccordion}
      procedures={getLastFinalizedOrder()?.procedures as any}
      cids={responseData.cids as any}
      proceduresObservation={getLastFinalizedOrder()?.procedure_observation}
      icon={<CheckCircle />}
    />,
    <OpmeAndSuppliers
      isFinished
      key="OpmeAndSuppliers"
      expanded={informationAccordionOpen === 'OpmeAndSuppliers'}
      handleChange={handleChangeInformationAccordion}
      opmeSolicitations={opmeSolicitation}
      opmeProvider={opmeProviders}
      opmeFinalized={opmeFinalized}
      anesthesiology={anesthesiology}
      opmeObservation={getLastFinalizedOrder()?.opme_observation}
      opmeDetails={getLastFinalizedOrder()?.opme_details}
      icon={<CheckCircle />}
    />,
    <GeneralComments
      key="GeneralComments"
      expanded={finishedAccordionOpen === 'GeneralComments'}
      handleChange={handleChangeFinishedAccordion}
      comment={getLastFinalizedOrder()?.general_observation}
      icon={<CheckCircle />}
    />
  ]

  const informationItems = [
    <PatientAndInsuranceData
      key="PatientAndInsuranceData"
      expanded={informationAccordionOpen === 'PatientAndInsuranceData'}
      handleChange={handleChangeInformationAccordion}
      patient={responseData.patient as Patient}
      healthInsurance={responseData.health_insurance as HealthInsurancePlans}
      icon={<CheckCircle />}
    />,
    (responseData.hospital?.hospital_id === HOSPITAL_SALVADOR_ID ||
      responseData.hospital?.hospital_id === HOSPITAL_EMEC_ID) && (
      <Cooperative
        cooperative={responseData.cooperative_name}
        icon={<CheckCircle />}
      />
    ),
    <Procedures
      key="ProceduresAndCid"
      expanded={informationAccordionOpen === 'Procedures'}
      handleChange={handleChangeInformationAccordion}
      procedures={responseData.procedures as any}
      procedureDetails={state.planning.procedure_details}
      cids={responseData.cids as any}
      icon={<CheckCircle />}
    />,
    <OpmeAndSuppliers
      key="OpmeAndSuppliers"
      expanded={informationAccordionOpen === 'OpmeAndSuppliers'}
      handleChange={handleChangeInformationAccordion}
      opmeSolicitations={opmeSolicitation}
      opmeProvider={opmeProviders}
      anesthesiology={anesthesiology}
      icon={<CheckCircle />}
    />,
    <ClinicalHistory
      key="ClinicalHistory"
      expanded={informationAccordionOpen === 'ClinicalHistory'}
      handleChange={handleChangeInformationAccordion}
      clinicalHistory={responseData.clinical_history?.clinical_history}
      allergy={responseData.clinical_history?.allergy as string[]}
      bloodTransfusion={responseData.clinical_history?.blood_transfusion}
      oncologyOrResearch={responseData.clinical_record?.oncology_or_research}
      psychologicalAspects={
        responseData.clinical_history?.psychological_aspects
      }
      icon={<CheckCircle />}
    />,
    <ClinicalRecord
      key="ClinicalRecord"
      expanded={informationAccordionOpen === 'ClinicalRecord'}
      handleChange={handleChangeInformationAccordion}
      hospitalizationLocation={
        responseData.clinical_record?.locale_hospitalization
      }
      cti={state.planning.cti}
      freeze={state.planning.freeze}
      extraBlood={state.planning.extraBlood}
      expectedDate={responseData.expected_date as any}
      technique={responseData.clinical_record?.technique as any}
      patientHospitalized={state.planning.patientHospitalized}
      bullishForecastDate={
        responseData.clinical_record?.bullish_forecast_date as any
      }
      hospitalizationType={
        responseData.clinical_record?.hospitalization_type as any
      }
      hospitalizationMode={
        responseData.clinical_record?.hospitalization_mode as any
      }
      requestedDailies={responseData.clinical_record?.requested_dailies as any}
      icon={<CheckCircle />}
    />
  ]

  const filteredReports = documents.filter(
    (document) =>
      document.type === OpenSurgicalOrderPatientDocument['Laudos dos exames']
  )

  const documentsNotToShow = ['LAUDO DE EXAME', 'Laudos dos exames']

  const documentsNotToUpload = ['PLANEJAMENTO CIRÚRGICO', 'Guia de autorização']

  const activeFinalizedOrders = finalizedOrders?.filter((item: any) => {
    return item.is_active === true
  })

  return (
    <S.TabWrapper>
      {['CONCLUDED', 'AUTHORIZED', 'CANCELLED'].includes(
        state.card.status[state.card.status.length - 1].status
      ) ? (
        <S.PlanningSection>
          <AccordionCardNew
            header={'Finalização do pedido'}
            expanded={mainInformationAccordionOpen === 'Fineshed'}
            accordionLabel="Fineshed"
            handleChange={handleChangeMainInformationAccordion}
            gap="8px"
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SupportTextNew weight="bold" color="primary600" size="large">
                {responseData.active_status}
              </SupportTextNew>

              <S.Separator />

              <SupportTextNew weight="normal" color="black" size="small">
                {moment
                  .utc(getLastFinalizedOrder()?.created_at)
                  .format('DD/MM/YYYY [às] HH[h]mm')}
              </SupportTextNew>
            </div>

            <SupportTextNew weight="bold" color="black">
              Informações de finalização
            </SupportTextNew>

            {finishedItems.map((item) => item)}
          </AccordionCardNew>
          <Separator />
        </S.PlanningSection>
      ) : (
        <S.PlanningSection>
          <AccordionCardNew
            header={'Finalização do pedido'}
            expanded={mainInformationAccordionOpen === 'Informations'}
            accordionLabel="Informations"
            handleChange={handleChangeMainInformationAccordion}
            gap="8px"
          >
            <CustomHeader
              date={activeFinalizedOrders[0]?.created_at}
              isActive={activeFinalizedOrders[0]?.is_active}
            />

            {/* <SupportTextNew weight="semiBold" color="black" size="large">
              {responseData.active_status === 'Autorizado'
                ? 'Finalização do pedido'
                : ''}
            </SupportTextNew>

            <SupportTextNew weight="bold" color="primary600" size="large">
              {responseData.active_status}
            </SupportTextNew>

            <SupportTextNew weight="bold" color="black">
              {responseData.active_status === 'Autorizado'
                ? 'Informações de finalização'
                : 'Informações'}
            </SupportTextNew> */}

            {state.card.active_status === 'ORDER_OPEN' ? (
              <S.ActionCard onClick={() => console.log('click')}>
                <div className="card-title">
                  <AlertCircle />
                  <SupportTextNew
                    color="neutral800"
                    weight="semiBold"
                    size="medium"
                  >
                    Ficha clinica
                  </SupportTextNew>
                </div>
                <Arrow />
              </S.ActionCard>
            ) : (
              informationItems.map((item) => item)
            )}
          </AccordionCardNew>
          <Separator />
        </S.PlanningSection>
      )}

      <S.PlanningSection>
        <AccordionCardNew
          header={'Laudos'}
          expanded={mainReportsAccordionOpen === 'Reports'}
          accordionLabel="Reports"
          handleChange={handleChangeMainReportsAccordion}
          gap="8px"
        >
          {filteredReports.length > 0 && (
            <ReportsCard
              key={filteredReports[0].type}
              documents={filteredReports}
              downloadDocument={downloadDocument}
              informationAccordionOpen={reportsAccordionOpen}
              planningTab
              showStatus={false}
            />
          )}

          {responseData.report_recommendation && (
            <S.ReportsRecommendations>
              <h1>Laudo indicado</h1>
              <span>{responseData.report_recommendation}</span>
            </S.ReportsRecommendations>
          )}

          {!responseData.report_recommendation &&
            filteredReports.length === 0 && (
              <S.NoReport>Nenhum laudo foi incluído.</S.NoReport>
            )}

          {isSurgicalOrderReview &&
            documentsList()?.map(
              (document) =>
                document.type ===
                  OpenSurgicalOrderPatientDocument['Laudos dos exames'] && (
                  <UploadButtonNew
                    onInput={(files: any) =>
                      uploadDocument(files, document.type)
                    }
                    name={document.type}
                    outlined
                    multiple={false}
                    fullWidth
                    size="large"
                    style={{
                      marginTop: '16px',
                      display: 'flex',
                      justifyItems: 'center',
                      alignItems: 'center'
                    }}
                  >
                    {<S.ButtonSpan>Incluir laudos</S.ButtonSpan>}
                  </UploadButtonNew>
                )
            )}
        </AccordionCardNew>
        <Separator />
      </S.PlanningSection>

      <S.PlanningSection>
        <AccordionCardNew
          header={'Outros Documentos'}
          expanded={mainOtherDocumentsAccordionOpen === 'OthersDocuments'}
          accordionLabel="OthersDocuments"
          handleChange={handleChangeMainOtherDocumentsAccordion}
          gap="8px"
        >
          {documentsList()
            .filter((document) => !documentsNotToShow.includes(document.type))
            .map((document, index) => (
              <DocumentAccordeon
                gap="8px"
                key={index}
                document={document}
                shadow="satin"
                padding="18px"
                onDownloadFile={downloadDocument}
                onUploadFile={(files: any) =>
                  uploadDocument(files, document.type)
                }
                onDeleteFile={deleteDocument}
                expandedDocument={informationAccordionOpen}
                handleChange={handleChangeInformationAccordion}
                uploadButton={
                  isSurgicalOrderReview &&
                  !documentsNotToUpload.includes(document.type)
                }
                showStatus={false}
              />
            ))}
        </AccordionCardNew>
        <Separator />
      </S.PlanningSection>
    </S.TabWrapper>
  )
}

export default WithLoading(PlanningTab)

type CustomHeaderProps = {
  date: string
  isActive: boolean
}

const CustomHeader = ({ date, isActive }: CustomHeaderProps) => {
  return (
    <S.CustomWrapper>
      <SupportTextNew
        weight="bold"
        color={isActive ? 'primary600' : 'neutral800'}
      >
        Autorizado
      </SupportTextNew>

      <S.Separator />
      <SupportTextNew weight="thin" color="neutral600" size="xsmall">
        {moment(date).utc().format(`DD [de] MMM[.] [de] YYYY [às] HH[h]mm`)}
      </SupportTextNew>
    </S.CustomWrapper>
  )
}
